// extracted by mini-css-extract-plugin
export default {"stages_paper":"ListingProgress_stages_paper__uO3P-","spin":"ListingProgress_spin__UzLWg"};